import React, { useState } from 'react';
import { allproducts, productBrands } from '../data/AllProducts';
import '../styles/News.css';
import '../styles/AllProducts.css';

const AllProducts = () => {
  const [activeBrand, setActiveBrand] = useState('All');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleFilter = (brand) => {
    if (brand === activeBrand || isTransitioning) return;

    setIsTransitioning(true);

    setTimeout(() => {
      setActiveBrand(brand);

      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 300);
  };

  const filtered =
    activeBrand === 'All'
      ? allproducts
      : allproducts.filter((p) => p.brand === activeBrand);

  return (
    <section className="products-section">
      <div className="products-container">

        {/* Title */}
        <h2 className="section-title">All Products</h2>

        {/* Filter */}
        <div className="products-filter">
          {['All', ...productBrands].map((brand, i) => (
            <button
              key={i}
              className={`filter-chip ${activeBrand === brand ? 'active' : ''}`}
              onClick={() => handleFilter(brand)}
            >
              {brand}
            </button>
          ))}
        </div>

        {/* Grid */}
        {filtered.length === 0 ? (
          <p className="products-empty">No products found.</p>
        ) : (
          <div className="products-grid">
            {filtered.map((product, i) => (
              <article
                key={i}
                className={`news-card ${
                  isTransitioning ? 'swipe-out-left' : 'swipe-in'
                }`}
              >
                {/* Image */}
                <div className="news-image">
                  <img
                    src={product.image}
                    alt={product.name}
                    loading="lazy"
                  />
                  <div className="news-category">
                    {product.brand}
                  </div>
                </div>

                {/* Content */}
                <div className="news-content">
                  <h3>{product.name}</h3>

                 

                  <p>
                    {product.badges.map((b) => b.label).join(' • ')}
                  </p>

                  <a
                    href={product.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="read-more"
                  >
                    View Product &gt;&gt;
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AllProducts;